/**
 * Some common utils. In style of lodash.
 * hewen.deng 2019/03/01
 */
import _ from 'lodash'
import dayjs from 'dayjs'

/** Boundary for determining school year. */
const SCHOOL_YEAR_BOUNDARY = 6

/** School year legality check: upper limit. */
const SCHOOL_YEAR_UPPER_LIMIT = 9999

/** School year legality check: lower limit. */
const SCHOOL_YEAR_LOWER_LIMIT = 1970

/** Rule to Get the implied school year. */
const defaultSchoolYear = () => {
  let now = dayjs()
  let year = now.year()
  let month = now.month()
  return month > SCHOOL_YEAR_BOUNDARY ? year : (year - 1)
}

/** Return the Chinese description. */
const getSchoolYearDesc = (year) => {
  if (year < SCHOOL_YEAR_LOWER_LIMIT || year > SCHOOL_YEAR_UPPER_LIMIT) {
    throw new Error('not a legal year ' + year)
  }
  return year + '-' + (year + 1) + '学年'
}

/** Rule to Get the implied school year. */
const getSchoolTerm = () => {
  let now = dayjs()
  let month = now.month()
  return month > SCHOOL_YEAR_BOUNDARY ? 2 : 1
}

/** Find parent id in map. */
const findParentId = (map, target) => {
  for (let k in map) {
    let values = map[k]
    if (!values) {
      return null
    }
    for (let i = 0, l = values.length; i < l; i++) {
      if (values[i].value === target) {
        return parseInt(k)
      }
    }
  }
  return null
}

/**
 * Helper for create element-ui form validation `required` rule.
 *
 * ex: { required: true, message: '请输入名称', trigger: 'blur' }
 * @param {*} message
 * @param {*} trigger default blur
 */
const createFormRequiredRule = (message, trigger) => {
  if (!trigger) {
    trigger = 'blur'
  }
  return { required: true, message, trigger }
}

/**
 * Helper for create element-ui form validation `required` rule.
 *
 * ex: { min: 11, max: 11, message: '11 位国内号码', trigger: 'blur' }
 * @param {*} min rang down limit
 * @param {*} max range upper limit
 * @param {*} message
 * @param {*} trigger default blur
 */
const createFormInputRule = (min, max, message, trigger) => {
  if (!trigger) {
    trigger = 'blur'
  }
  if (min === max) {
    return { len: min, message, trigger }
  }
  return { min, max, message, trigger }
}

/**
 * Check if a simple object's properies value all null.
 * ex: { x: null, y: null, z: null } => true
 * @param {*} object
 */
const isObjectPropertiesAllNull = (object) => {
  for (let k in object) {
    if (object[k] !== null) {
      return false
    }
  }
  return true
}

/** Check if a number or string is int. */
const isPositiveInt = (val) => {
  return _.isInteger(val) || /^\d+$/.test(val)
}

/** Check if a number or string is a legal score. */
const isScore = (val) => {
  return /^\d+(\.5)?$/.test(val)
}

export default {
  defaultSchoolYear,
  getSchoolYearDesc,
  getSchoolTerm,
  findParentId,
  createFormRequiredRule,
  createFormInputRule,
  isObjectPropertiesAllNull,
  isPositiveInt,
  isScore
}



// WEBPACK FOOTER //
// ./src/util/common-utils.js